<template>
    <form class="kt-form" @submit.prevent="submit" id="transaction_routing_setting" v-if="setting_status == 'success'">
        <kt-row id="first_row">
            <kt-col lg="12" md="12" sm="12">
                <kt-form-group>
                    <kt-form-label for="switch_status">
                        {{ $t('transaction_routing.switch_status') }}
                    </kt-form-label>
                    <div class="custom-control custom-checkbox" id="switch_status-div">
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="switch_status"
                                name="switch_status"
                                @change="changeLabel"
                                v-model="setting.switch_status"
                        >
                        <label class="custom-control-label" id="switch_status_label" for="switch_status"></label>
                    </div>
                </kt-form-group>
            </kt-col>
        </kt-row>
        <kt-row v-if="!setting.switch_status">
            <kt-col lg="4" md="4" xs="6">
                <kt-form-group>
                    <kt-form-label for="priority">
                        {{ $t('transaction_routing.choose_psp') }}
                    </kt-form-label>
                    <kt-form-select id="priority"
                            class="form-control"
                            name="priority"
                            v-model="setting.priority"
                    >
                        <option value="0" :selected = "setting.priority == 0">
                            {{ $t('transaction_routing.random') }}
                        </option>
                        <option value="1" :selected = "setting.priority == 1">
                            {{ $t('transaction_routing.manually') }}
                        </option>
                    </kt-form-select>
                </kt-form-group>
            </kt-col>
            <kt-col v-if="setting.priority == 1" lg="12" md="12" xs="12">
                <div v-for="(psp, index) in active_psp" :key="index">
                    <kt-row>
                        <kt-col lg="4" md="4" xs="12">
                            <kt-form-group>
                                <kt-form-label for="priority">
                                    {{ $t('transaction_routing.priority.' + (index + 1)) }}
                                </kt-form-label>
                                <kt-form-select :id="'priority_' + (index + 1)"
                                        class="form-control"
                                        :name="'priority_' + (index + 1)"
                                        v-model="setting.selected_manually[(index + 1)]"
                                >
                                    <option v-for="(psp, index) in active_psp"
                                            :value="psp"
                                            :key="index"
                                            :selected="setting.selected_manually[(index + 1)] === psp"
                                    >
                                        {{ $t('psp.' + psp) }}
                                    </option>
                                </kt-form-select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </div>
            </kt-col>
        </kt-row>
        <div v-if="setting.switch_status" class="container p-3 pt-5 my-4 border in-border-header"
             style="padding-top: 1.5rem !important;">
            <div class="section-header">
                {{ $t('transaction_routing.metrics') }}
            </div>
            <kt-row>
                <kt-col lg="4" md="4" sm="12">
                    {{ $t('transaction_routing.token_time') }}
                </kt-col>
                <kt-col lg="3" md="3" sm="12">
                    <kt-form-group style="margin-left: 28%" class="mt-sm-2">
                        <kt-form-label for="token_time_weight">
                            {{ $t('transaction_routing.weight') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="token_time_weight"
                                id="token_time_weight"
                                v-model="setting.token_time.weight"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="5" md="5" sm="12" class="container p-3 pt-5 my-4 border in-border-header">
                    <div class="section-header">
                        {{ $t('transaction_routing.metric_score') }}
                    </div>
                    <kt-row v-for="(object, index) in setting.token_time.scores" :key="index">
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'token_time_from_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.from') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'token_time_from_' + index"
                                            :id="'token_time_from_' + index"
                                            v-model="setting.token_time.scores[index].from"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'token_time_to_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.to') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'token_time_to_' + index"
                                            :id="'token_time_to_' + index"
                                            v-model="setting.token_time.scores[index].to"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'token_time_score_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.rate') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'token_time_score_' + index"
                                            :id="'token_time_score_' + index"
                                            v-model="setting.token_time.scores[index].score"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                    </kt-row>
                </kt-col>
            </kt-row>
            <hr>
            <kt-row>
                <kt-col lg="4" md="4" sm="12">
                    {{ $t('transaction_routing.verify_time') }}
                </kt-col>
                <kt-col lg="3" md="3" sm="12">
                    <kt-form-group style="margin-left: 28%" class="mt-sm-2">
                        <kt-form-label for="verify_time_weight">
                            {{ $t('transaction_routing.weight') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="verify_time_weight"
                                id="verify_time_weight"
                                v-model="setting.verify_time.weight"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="5" md="5" sm="12" class="container p-3 pt-5 my-4 border in-border-header">
                    <div class="section-header">
                        {{ $t('transaction_routing.metric_score') }}
                    </div>
                    <kt-row v-for="(object, index) in setting.verify_time.scores" :key="index">
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'verify_time_from_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.from') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'verify_time_from_' + index"
                                            :id="'verify_time_from_' + index"
                                            v-model="setting.verify_time.scores[index].from"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'verify_time_to_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.to') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'verify_time_to_' + index"
                                            :to="'verify_time_to_' + index"
                                            v-model="setting.verify_time.scores[index].to"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'verify_time_score_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.rate') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'verify_time_score_' + index"
                                            :id="'verify_time_score_' + index"
                                            v-model="setting.verify_time.scores[index].score"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                    </kt-row>
                </kt-col>
            </kt-row>
            <hr>
            <kt-row>
                <kt-col lg="4" md="4" sm="12">
                    {{ $t('transaction_routing.on_gateway_time') }}
                </kt-col>
                <kt-col lg="3" md="3" sm="12">
                    <kt-form-group style="margin-left: 28%" class="mt-sm-2">
                        <kt-form-label for="on_gateway_time_weight">
                            {{ $t('transaction_routing.weight') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="on_gateway_time_weight"
                                id="on_gateway_time_weight"
                                v-model="setting.on_gateway_time.weight"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="5" md="5" sm="12" class="container p-3 pt-5 my-4 border in-border-header">
                    <div class="section-header">
                        {{ $t('transaction_routing.metric_score') }}
                    </div>
                    <kt-row v-for="(object, index) in setting.on_gateway_time.scores" :key="index">
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'on_gateway_time_from_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.on_gateway_time_from_') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'on_gateway_time_from_' + index"
                                            :id="'on_gateway_time_from_' + index"
                                            v-model="setting.on_gateway_time.scores[index].from"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'on_gateway_time_to_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.on_gateway_time_to_') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'on_gateway_time_to_' + index"
                                            :to="'on_gateway_time_to_' + index"
                                            v-model="setting.on_gateway_time.scores[index].to"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'on_gateway_time_score_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.rate') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'on_gateway_time_score_' + index"
                                            :id="'on_gateway_time_score_' + index"
                                            v-model="setting.on_gateway_time.scores[index].score"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                    </kt-row>
                </kt-col>
            </kt-row>
            <hr>
            <kt-row>
                <kt-col lg="4" md="4" sm="12">
                    {{ $t('transaction_routing.succeed_transaction_rate') }}
                </kt-col>
                <kt-col lg="3" md="3" sm="12">
                    <kt-form-group style="margin-left: 28%" class="mt-sm-2">
                        <kt-form-label for="succeed_transaction_rate_weight">
                            {{ $t('transaction_routing.weight') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="succeed_transaction_rate_weight"
                                id="succeed_transaction_rate_weight"
                                v-model="setting.succeed_transaction_rate.weight"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="5" md="5" sm="12" class="container p-3 pt-5 my-4 border in-border-header">
                    <div class="section-header">
                        {{ $t('transaction_routing.metric_score') }}
                    </div>
                    <kt-row v-for="(object, index) in setting.succeed_transaction_rate.scores" :key="index">
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'succeed_transaction_rate_from_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.succeed_transaction_rate_from_') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'succeed_transaction_rate_from_' + index"
                                            :id="'succeed_transaction_rate_from_' + index"
                                            v-model="setting.succeed_transaction_rate.scores[index].from"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'succeed_transaction_rate_to_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.succeed_transaction_rate_to_') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'succeed_transaction_rate_to_' + index"
                                            :to="'succeed_transaction_rate_to_' + index"
                                            v-model="setting.succeed_transaction_rate.scores[index].to"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'succeed_transaction_rate_score_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.rate') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'succeed_transaction_rate_score_' + index"
                                            :id="'succeed_transaction_rate_score_' + index"
                                            v-model="setting.succeed_transaction_rate.scores[index].score"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                    </kt-row>
                </kt-col>
            </kt-row>
            <hr>
            <kt-row>
                <kt-col lg="4" md="4" sm="12">
                    {{ $t('transaction_routing.psp_error_rate') }}
                </kt-col>
                <kt-col lg="3" md="3" sm="12">
                    <kt-form-group style="margin-left: 28%" class="mt-sm-2">
                        <kt-form-label for="psp_error_rate_weight">
                            {{ $t('transaction_routing.weight') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="psp_error_rate_weight"
                                id="psp_error_rate_weight"
                                v-model="setting.psp_error_rate.weight"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="5" md="5" sm="12" class="container p-3 pt-5 my-4 border in-border-header">
                    <div class="section-header">
                        {{ $t('transaction_routing.metric_score') }}
                    </div>
                    <kt-row v-for="(object, index) in setting.psp_error_rate.scores" :key="index">
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'psp_error_rate_from_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.succeed_transaction_rate_from_') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="text"
                                            :name="'psp_error_rate_from_' + index"
                                            :id="'psp_error_rate_from_' + index"
                                            v-model="setting.psp_error_rate.scores[index].from"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'psp_error_rate_to_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.succeed_transaction_rate_to_') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="text"
                                            :name="'psp_error_rate_to_' + index"
                                            :to="'psp_error_rate_to_' + index"
                                            v-model="setting.psp_error_rate.scores[index].to"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                        <kt-col lg="4" md="4" sm="4">
                            <kt-form-section>
                                <kt-form-group>
                                    <kt-form-label :for="'psp_error_rate_score_' + index" v-if="index == 1">
                                        {{ $t('transaction_routing.rate') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            type="number"
                                            :name="'psp_error_rate_score_' + index"
                                            :id="'psp_error_rate_score_' + index"
                                            v-model="setting.psp_error_rate.scores[index].score"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-form-section>
                        </kt-col>
                    </kt-row>
                </kt-col>
            </kt-row>
        </div>
        <kt-form-action class="mt-4" v-if="$can('manage-transaction-setting', 'transaction')">
            <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                {{ $t('btn.edit') }}
            </button>
        </kt-form-action>
    </form>
</template>
<script>
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import {KTApp} from "@/plugins/core/app";
import {transactionRoutingService, marketingService} from "@/common/api.service";
import {KTUtil} from "@/plugins/core/util";
import {mapGetters} from "vuex";

export default {
    name: "setting",
    data() {
        return {
            active_psp : []
        }
    },
    methods: {
        submit(e) {
            let form = $('#transaction_routing_setting')
            let btn = $('#submit_btn')
            if (this.setting.switch_status) {
                this.setting.priority = 0
            }

            KTApp.progress(btn)

            transactionRoutingService.setCoreSetting(this.setting)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                })
                .catch(({response}) => {
                    let message = document.createElement('div')
                    message.innerHTML = response.data.message
                    Object.keys(response.data.data).forEach(function (item) {
                        var li = document.createElement('li')
                        li.innerText = response.data.data[item][0]
                        message.insertAdjacentElement('beforeend', li)
                    })
                    this.showMsg(form, 'danger', message)
                })
                .finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                })
        },
        changeLabel() {
            let label = $('#switch_status_label')
            let checkbox = $('#switch_status')

            if (checkbox.is(':checked')) {
                label.html(i18n.t('label.active'))
            } else {
                label.html(i18n.t('label.inactive'))
            }
        },
        fillActivePsp() {
            let active_psp = this.active_psp
            Object.keys(this.setting.active_psp).forEach(function (psp) {
                active_psp.push(psp)
            })
            this.active_psp = active_psp
        }
    },
    computed: {
        ...mapGetters('transactionRouting', [
            'setting', 'setting_status'
        ]),
    },
    mounted() {
        this.$store.dispatch('transactionRouting/fetchSetting').finally(() => {
            this.changeLabel()
            this.fillActivePsp()
        })

    },
}
</script>
<style scoped>
</style>